import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-task",
  "use": "icon-task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-task\"><path d=\"M228.928 320h534.144v64H228.928zM228.928 512h534.144v64H228.928zM228.928 704h534.144v64H228.928z\" p-id=\"3217\" /><path d=\"M124.48 950.272L124.16 118.016h169.024v34.56c0 38.656 31.296 70.144 69.76 70.144h279.488a70.016 70.016 0 0 0 69.696-70.144v-34.56l168.704-0.32 0.32 832.32-756.672 0.256z m517.824-866.816l0.128 69.44-279.424-0.32v-69.12l-0.128-0.384 279.424 0.384zM880.704 50.56h-178.368c-12.096-22.208-34.24-37.312-59.904-37.312H362.88c-25.6 0-47.808 15.104-59.904 37.312H124.16c-38.4 0-69.504 33.28-69.504 74.24v820.736c0 40.96 31.232 74.24 69.568 74.24h756.928c38.4 0 69.44-33.28 69.504-74.24V124.8c-0.128-41.152-31.488-74.368-69.952-74.24z\" p-id=\"3218\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/task.svg
// module id = EK3d
// module chunks = 42